import { useMemo } from "react";
import type { Dispatch, SetStateAction } from "react";
import i18n from "i18next";
import type { TFunction } from "i18next";
import "./CauseList.css";
import { useCauseDelete } from "../hooks/useCauseDelete";
import type { CauseType } from "../../../types/models";
import type { FeelingCause } from "types/feeling-cause";

const MOOD_SORT_ORDER = ["Anxiety", "Flow", "Confident", "Apathy"] as const;

type CauseListEntry = (CauseType | FeelingCause) & {
  translation?: string;
  cause?: string;
  archived?: boolean;
};

interface Props {
  causeTypes: CauseListEntry[];
  t: TFunction;
  setActiveCauseTypes?: Dispatch<SetStateAction<CauseListEntry[]>>;
  organizationId: string;
  type?: string;
  moodsTranslator?: Record<string, string>;
  setActiveTeamCauseTypes?: Dispatch<SetStateAction<CauseListEntry[]>>;
}

export default function CauseList({
  causeTypes,
  t,
  setActiveCauseTypes,
  setActiveTeamCauseTypes,
  organizationId,
}: Props) {
  const { handleCauseDelete } = useCauseDelete({
    setActiveCauseTypes,
    setActiveTeamCauseTypes,
  });

  const visibleCauses = useMemo(() => {
    if (!causeTypes?.length) return [];

    const ordering: Record<string, number> = {};
    for (let i = 0; i < MOOD_SORT_ORDER.length; i++) {
      ordering[MOOD_SORT_ORDER[i]] = i;
    }
    const tail = MOOD_SORT_ORDER.length;

    return [...causeTypes]
      .filter((c) => c.archived !== true)
      .sort((a, b) => (ordering[a.mood] ?? tail) - (ordering[b.mood] ?? tail));
  }, [causeTypes]);

  return (
    <>
      <div className="select-component__duration-section">
        {visibleCauses.length > 0 ? (
          <>
            {visibleCauses.map((cause) => {
              return (
                <div key={cause.id}>
                  <button
                    className="strength-button select-component__duration-button two-part-button"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                    onClick={() => {}}
                  >
                    <span>
                      {cause.causeTypeTranslation &&
                      cause.causeTypeTranslation[i18n.language]
                        ? cause.causeTypeTranslation[i18n.language]
                        : cause.translation || "No translation available"}
                      <> | {cause.mood || cause.cause || "Unknown"}</>
                    </span>
                    <span
                      className="right"
                      onClick={(e) => {
                        e.stopPropagation();
                        void handleCauseDelete(cause, organizationId);
                      }}
                      title={t("settings.delete", { defaultValue: "Delete" })}
                    >
                      ×
                    </span>
                  </button>
                </div>
              );
            })}
          </>
        ) : (
          <div className="cause-list__empty">
            <p>No causes found</p>
          </div>
        )}
      </div>
    </>
  );
}
